






































import Vue from 'vue'
import SectionEditChip from '../../components/SectionEditChip.vue'
import NoDataBlock from '../../components/NoDataBlock.vue'

export default Vue.extend({
  name: 'skill-block',
  components: { NoDataBlock, SectionEditChip },
  props: {
    pilot: {
      type: Object,
      required: true,
    },
  },
})
